//------------------------
// process copy rune adjs
//------------------------
export default function processCopyStaticRuneAdjs({ static_rune, target_rune, character }) {
  console.log('--------------------------')
  console.log(
    'IN processCopyStaticRuneAdjs target_rune = ',
    target_rune.name,
    ' static_rune = ',
    static_rune,
    ' target_rune = ',
    target_rune,
  )
  //-----------------------
  // defensive check parms
  //-----------------------
  if (!static_rune || !target_rune || !character) {
    console.error('processCopyStaticRuneAdjs: missing required parms')
    return { target_rune, character }
  }
  /*

  Notes:
  ------

  Summary: From static rune -> load into new character-rune adjs arrays.

  - The following adjs arrays are typically downloaded from the db during initial rune load for existing runes.
  - FOR NEW RUNES this info needs to be added to the new character-rune object from the associated static rune
    whilst waiting for the rune to be committed to the db:

      A. skill_adjs
      B. ability_adjs
      C. characteristics_adjs

  Example downloaded data for new rune "My Mega Rune" (need to build same structure):
  -----------------------------------------------------------------------------------

  "skill_adjs": [
      {
          "id": 11,
          "rune_name": "My Mega Rune",
          "name": "Assassinate",
          "adj_value": 5
      },
      {
          "id": 10,
          "rune_name": "My Mega Rune",
          "name": "Athletics",
          "adj_value": 5
      },
      {
          "id": 12,
          "rune_name": "My Mega Rune",
          "name": "Runecasting",
          "adj_value": 5
      }
  ],

  "ability_adjs": [
    {
        "id": 6,
        "rune_name": "My Mega Rune",
        "name": "damage_mod_melee",
        "label": "Melee Damage",
        "adj_value": 1
    }
  ],

  "characteristics_adjs": [
    {
        "id": 8,
        "rune_name": "My Mega Rune",
        "name": "str",
        "adj_value": 1
    },
    {
        "id": 9,
        "rune_name": "My Mega Rune",
        "name": "dex",
        "adj_value": 1
    }
  ],

  */
  //--------------------------------------------------
  // A. load skills adjs to new rune e.g. +10 Stealth
  //--------------------------------------------------
  if (!static_rune.skill_adjs) {
    console.log('A1. static_rune.skill_adjs missing')
    target_rune.skill_adjs = []
  } else {
    target_rune.skill_adjs = static_rune.skill_adjs.map((adj) => ({ ...adj }))
    console.log('A2. static_rune.skill_adjs copied = ', target_rune.skill_adjs)
  }
  //-------------------------------------------------------
  // B. load ability adjs to new rune e.g. +1 melee damage
  //-------------------------------------------------------
  if (!static_rune.ability_adjs) {
    console.log('B1. static_rune.ability_adjs missing')
    target_rune.ability_adjs = []
  } else {
    target_rune.ability_adjs = static_rune.ability_adjs.map((adj) => ({ ...adj }))
    console.log('B2. static_rune.ability_adjs copied = ', target_rune.ability_adjs)
  }
  //------------------------------------------------------
  // C. load characteristics adjs to new rune e.g. +1 CON
  //------------------------------------------------------
  if (!static_rune.chars_adjs) {
    console.log('C1. static_rune.chars_adjs missing')
    target_rune.chars_adjs = []
  } else {
    target_rune.characteristics_adjs = static_rune.chars_adjs.map((adj) => ({ ...adj }))
    console.log('C2. static_rune.chars_adjs copied = ', target_rune.characteristics_adjs)
  }
  //--------------------------------------------------------------
  // return mutated objects for clarity (optional use by callers)
  //--------------------------------------------------------------
  return { target_rune, character }
}
